<template>
  <input
    type="text"
    ref="input"
    v-bind:value="format(value)"
    v-on:input="parse($event.target.value)"
    @keypress="isNumber($event)"
  />
</template>

<script>
export default {
  props: {
    value: {
      required: true,
    },
  },
  data() {
    return {
      isInputActive: false,
    };
  },
  methods: {
    format: function () {
      var v;
      if (this.value > 0) {
        v = this.value;
      } else {
        v = "";
      }
      // console.log('f: ' + v)
      return v;
    },
    parse: function (value) {
      if (value === "") {
        value = 0;
      }
      // console.log('v: ' + value)
      /* change by adding parseInt function*/
      this.$emit("input", parseInt(value, 10));
    },
    isNumber: function (event) {
      var charCode = event.keyCode;
      if (charCode < 48 || charCode > 57) {
        event.preventDefault();
      } else {
        return true;
      }
    },
  },
  /*
  computed: {
    displayValue: {
      get: function() {
        if (this.isInputActive) {
          return this.value.toString()
        } else {
          // User is not modifying now. Format display value for user interface
          return "$ " + this.value.toFixed(2).replace(/(\d)(?=(\d{3})+(?:\.\d+)?$)/g, "$1,")
        }
      },
      set: function(modifiedValue) {
        // Recalculate value after ignoring "$" and "," in user input
        let newValue = parseFloat(modifiedValue.replace(/[^\d\.]/g, ""))
        // Ensure that it is not NaN
        if (isNaN(newValue)) {
          newValue = 0
        }
        this.$emit('input', newValue)
      }
    }
  }
  */
};
</script>

<!--
<style scoped>
  .sttext {
  font-family: "khmer OS";
  font-size: 12px;
  }
</style>
-->
